import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// These imports are commented out but will be needed when setting up Firebase emulators
// import { connectAuthEmulator } from 'firebase/auth';
// import { connectFirestoreEmulator } from 'firebase/firestore';
// import { connectStorageEmulator } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBt0DbFUcVaw0nC-3TTpcHiNaKEnj4vLP4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ucf-lab-inventory.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "ucf-lab-inventory",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ucf-lab-inventory.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "408293031424",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:408293031424:web:9ecf4681c81522f76ee2e5",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-FMGHHDNSQT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Debug logging to verify bucket configuration
console.log('Firebase Storage Bucket Config:', firebaseConfig.storageBucket);
console.log('Firebase Storage Instance Bucket:', storage._location?.bucket || 'unknown');

// Use local emulators in development mode
if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
  // To connect to Firebase emulators, uncomment the imports at the top of this file
  // and uncomment these lines when you have emulators set up:
  // 
  // connectAuthEmulator(auth, 'http://localhost:9099');
  // connectFirestoreEmulator(db, 'localhost', 8080);
  // connectStorageEmulator(storage, 'localhost', 9199);
  
  console.log('Using development mode with placeholder Firebase configuration');
}

export { auth, db, storage };